<template>
  <footer className="m-footer">
    <div className="go-to-main-site">
      <a
        v-ga-event="'Main Site'"
        href="/maplestory"
        @click="$emit('go-to-main-click')"
        @click.middle="$emit('go-to-main-click')"
      >
        <span className="icon-ms_leaf"></span>Go to Main Site
      </a>
    </div>
    <div className="follow-us">
      <a
        v-ga-event="'facebook'"
        class="icon icon--facebook"
        href="https://www.facebook.com/maplestory"
        target="_blank"
        @click="$emit('link-click', 'facebook')"
        @click.middle="$emit('link-click', 'facebook')"
      >
        <SocialIcons type="facebook" />
      </a>
      <a
        v-ga-event="'twitter'"
        class="icon icon--twitter"
        href="https://twitter.com/maplestory"
        target="_blank"
        @click="$emit('link-click', 'twitter')"
        @click.middle="$emit('link-click', 'twitter')"
      >
        <SocialIcons type="twitter" />
      </a>
      <a
        v-ga-event="'youtube'"
        class="icon icon--youtube"
        href="https://www.youtube.com/user/maplestory"
        target="_blank"
        @click="$emit('link-click', 'youtube')"
        @click.middle="$emit('link-click', 'youtube')"
      >
        <SocialIcons type="youtube" />
      </a>
      <a
        v-ga-event="'instagram'"
        class="icon icon--instagram"
        href="https://www.instagram.com/maplestory/"
        target="_blank"
        @click="$emit('link-click', 'instagram')"
        @click.middle="$emit('link-click', 'instagram')"
      >
        <SocialIcons type="instagram" />
      </a>
      <a
        v-ga-event="'twitch'"
        class="icon icon--twitch"
        href="https://www.twitch.tv/maplestory"
        target="_blank"
        @click="$emit('link-click', 'twitch')"
        @click.middle="$emit('link-click', 'twitch')"
      >
        <SocialIcons type="twitch" />
      </a>
      <a
        v-ga-event="'discord'"
        class="icon icon--discord"
        href="https://discord.gg/maplestory"
        target="_blank"
        @click="$emit('link-click', 'discord')"
        @click.middle="$emit('link-click', 'discord')"
      >
        <SocialIcons type="discord" />
      </a>
      <a
        v-ga-event="'tiktok'"
        class="icon icon--tiktok"
        href="https://www.tiktok.com/@maplestory"
        target="_blank"
        @click="$emit('link-click', 'tiktok')"
        @click.middle="$emit('link-click', 'tiktok')"
      >
        <SocialIcons type="tiktok" />
      </a>
    </div>

    <div className="copy-links">
      <div className="copyright">
        © {{ new Date().getFullYear() }} NEXON Korea Corporation & NEXON America Inc. All Rights Reserved.
      </div>

      <div className="account-links">
        <a
          v-ga-event="'Privacy Policy'"
          href="//www.nexon.com/main/en/legal/privacy"
          target="_blank"
          className="privacy"
          @click="$emit('link-click', 'Privacy Policy')"
          @click.middle="$emit('link-click', 'Privacy Policy')"
        >
          Privacy Policy
        </a>
        <a
          v-ga-event="'Terms of Use'"
          href="//www.nexon.com/main/en/legal/tou/"
          target="_blank"
          className="termsofuse"
          @click="$emit('link-click', 'Terms of Use')"
          @click.middle="$emit('link-click', 'Terms of Use')"
        >
          Terms of Use
        </a>
        <a
          v-ga-event="'Cookie Policy'"
          target="_blank"
          :href="`https://${nexonComEnv}www.nexon.com/main/cookie-policy`"
          @click="$emit('link-click', 'Cookie Policy')"
          @click.middle="$emit('link-click', 'Cookie Policy')"
          >Cookie Policy</a
        >
        <a
          v-ga-event="'Cookie Settings'"
          target="_blank"
          className="ot-sdk-show-settings"
          @click="$emit('link-click', 'Cookie Settings')"
          >Cookie Settings</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
  import '@/assets/fonts/microsites/common/icons.scss'
  import SocialIcons from '@/components/SocialIcons.vue'
  import OneTrust from '@/services/browser/OneTrust'

  export default {
    name: 'MicrositeFooter',
    components: {
      SocialIcons,
    },
    props: {
      color: {
        type: String,
        default: 'red',
      },
      hoverColor: {
        type: String,
        default: 'blue',
      },
      backgroundColor: {
        type: String,
        default: 'black',
      },
    },
    data() {
      return {
        nexonComEnv: import.meta.env.VITE_ENV_PREFIX,
      }
    },
    mounted() {
      OneTrust()
    },

    methods: {
      cookieSettingMenu() {
        setTimeout(() => {
          const $cookieSettingMenu = document.querySelector('.ot-sdk-show-settings')
          if ($cookieSettingMenu.firstChild.nodeValue.includes('Cookie Settings')) {
            $cookieSettingMenu.style.display = 'none'
          }
        }, 100)
      },
    },
  }
</script>

<style scoped lang="scss">
  @use 'sass:math';
  @use '@/assets/scss/_functions.scss' as *;
  @function pxToRem($px, $fontBase: 24, $round: true, $fractionDigits: 3) {
    $number: math.div(
      $px,
      ($px * 0 + 1)
    ); // convert to number without units, for example $px: 10px will be 10 and $px: 10 as well will be 10
    $fontBase: math.div($fontBase, ($fontBase * 0 + 1));

    $pxToRem: math.div($number, $fontBase);

    @if ($round == true) {
      // rounding the number and adjust the amount of decimals based on the $fractionDigits
      $power: math.pow(10, $fractionDigits);
      $pxToRem: math.div(math.round($power * $pxToRem), $power);
    }
    @return $pxToRem + em;
  }

  $footerRest: v-bind(color);
  $footerHover: v-bind(hoverColor);
  $backgroundColor: v-bind(backgroundColor);
  .m-footer {
    z-index: 2;
    font-size: 1rem;
    color: v-bind(color);
    padding: 1em 0 1em; //background: white;
    text-align: center;
    background: $backgroundColor;
    .copyright-game {
      position: relative;
      font-size: 0.6em;
      color: $footerHover;
      margin-bottom: 0.6em;
    }
    .go-to-main-site {
      display: inline-block;
      font-size: 0.8em;
      text-transform: uppercase;
      a {
        color: v-bind(color);
        text-decoration: none;
        transition: 0.2s ease-in-out;
        position: relative;
        .icon-ms_leaf {
          display: inline-block;
          margin-right: 0.4em;
          vertical-align: sub;
          &:before {
            transition: 0.3s ease-in-out;
            font-size: 1.1em;
            color: v-bind(color);
          }
        }
      }
      &:hover {
        a {
          color: v-bind(hoverColor);
          .icon-ms_leaf {
            &:before {
              color: v-bind(hoverColor);
            }
          }
        }
      }
    }
    .copy-links {
      display: flex;
      justify-content: center;
      a {
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .follow-us {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-top: pxToRem(55);
      margin-bottom: pxToRem(58);
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: fill 0.2s ease-in-out;
        margin-right: pxToRem(75);
        :deep() {
          svg {
            width: pxToRem(40.35);
            height: auto;
            path {
              display: inline-block;
              fill: $footerRest;
              transition: fill 0.2s ease-in-out;
            }
          }
        }

        &--twitter {
          :deep() {
            svg {
              width: pxToRem(30);
            }
          }
        }

        &--instagram {
          :deep() {
            svg {
              width: pxToRem(36);
            }
          }
        }

        &--twitch {
          :deep() {
            svg {
              width: pxToRem(32);
            }
          }
        }

        &--tiktok {
          :deep() {
            svg {
              width: pxToRem(36);
            }
          }
        }

        &:last-child {
          margin-right: 0;
        }

        &:hover {
          :deep() {
            svg {
              path {
                fill: $footerHover;
              }
            }
          }
        }
      }
    }
    .locales {
      display: flex;
      justify-content: center;
      margin-bottom: 0.75em;
    }
    .social-links {
      display: flex;
      justify-content: center;
      .nav-item {
        padding: 0 0.2em;
      }
      i {
        font-size: 1.2em;
      }
    }
    .account-links {
      display: flex;
      justify-content: center;
      margin-left: 2em;
      a {
        font-size: 0.6em;
        color: v-bind(color);
        transition: 0.2s ease-in-out;
        margin: 0 0.3em;
        &:hover {
          color: $footerHover;
          //text-shadow: 2px 2px 5px $footerHover;
          text-decoration: underline;
          transition: 0.2s ease-in-out;
        }
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }

      margin-bottom: 0.25em;
      li {
        border-left: 2px solid $footerRest;
        line-height: 1;
        &:first-child {
          border-left: 0;
        }
      }
    }
    .copyright {
      position: relative;
      font-size: 0.7em;
    }
    .game-rating {
      position: absolute;
      top: 4.5em;
      right: 10.5em;
      img {
        max-height: 5em;
      }
    }
  }

  .m-maplelane-footer__text {
    max-width: 48em;
    margin: 0 auto 6em;
    text-align: center;
    font-size: 0.9em;
    color: white;
  }

  .mobile,
  .tablet {
    .m-footer {
      padding: 1em 1em 1.5em;
      z-index: 999;
      .follow-us {
        margin-top: pxToRemTablet(50);
        margin-bottom: pxToRemTablet(50);
        .icon {
          margin-right: pxToRemTablet(75);
          :deep() {
            svg {
              width: pxToRemTablet(40);
            }
          }

          &--twitter {
            :deep() {
              svg {
                width: pxToRemTablet(30);
              }
            }
          }

          &--instagram {
            :deep() {
              svg {
                width: pxToRemTablet(36);
              }
            }
          }

          &--twitch {
            :deep() {
              svg {
                width: pxToRemTablet(32);
              }
            }
          }

          &--tiktok {
            :deep() {
              svg {
                width: pxToRemTablet(36);
              }
            }
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
      .social-links {
        .follow-us {
          display: none;
        }
        i {
          font-size: 2em;
          &.svg {
            width: 1.75em;
            height: 1.75em;
          }
          svg {
            width: 1.75em;
            height: 1.75em;
          }
        }
      }
      .go-to-main-site,
      .copyright {
        font-size: 0.8em;
      }
      .go-to-main-site {
        padding-left: 0;
      }
      .copyright {
        line-height: 1.1em;
        margin-bottom: 0.6em;
      }
      .copy-links {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        padding: 0;
      }
      .account-links {
        margin-left: 0;
        flex-wrap: wrap;
        a {
          font-size: 0.6em;
        }
        .nav-item {
          //margin-bottom: 0.5em;
          &.nav-item-terms {
            border: 0;
          }
        }
      }
    }
    .m-maplelane-footer__text {
      width: 88%;
      margin: 0 auto 6.5em;
      text-align: center;
      font-size: 0.58em;
      color: white;
    }
  }
</style>
